import { Component, inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { gungAddRemoveSpinner } from 'gung-common';
import { GungModalService, Order, OrderDetailsComponent } from 'gung-standard';
import { JeevesOrderActionConfigService } from '../../services/jeeves-order-action-config/jeeves-order-action-config.service';
import { JeevesOrderDetailsConfigService } from '../../services/jeeves-order-details-config.service';
import { JeevesOrderService } from '../../services/jeeves-order.service';
@Component({
    selector: 'gung-jeeves-jeeves-order-details',
    templateUrl: './jeeves-order-details.component.html',
    styleUrls: ['./jeeves-order-details.component.css'],
    standalone: false
})
export class JeevesOrderDetailsComponent extends OrderDetailsComponent {
  protected orderService = inject(JeevesOrderService);
  public configService = inject(JeevesOrderActionConfigService);
  protected modalService = inject(NgbModal);
  protected orderDetailsConfig = inject(JeevesOrderDetailsConfigService);
  protected gungModalService = inject(GungModalService);
  protected translateService = inject(TranslateService);

  public isOrderEditable = (order: Order, isSales: boolean) => {
    return this.orderDetailsConfig.isOrderEditable(order, isSales);
  };

  public addRow() {
    this.orderDetailsConfig.openAddOrderRowModal(this.order);
  }

  saveOrderMessage(element) {
    gungAddRemoveSpinner(element.target);
    let oh = { oh: { editext: this.order.extra.oh.editext } };

    this.orderService.updateOrderHeader({ id: this.order.id, extra: oh } as any).subscribe(
      result => {
        this.gungModalService
          .openConfirmYesNoModal(
            undefined,
            this.translateService.instant('CHANGE_SAVED_SUCCESS'),
            { size: 'sm' },
            'OK',
            null
          )
          .then(_ => {});
      },
      error => {
        gungAddRemoveSpinner(element.target);
        this.gungModalService
          .openConfirmYesNoModal(
            undefined,
            this.translateService.instant('AN_ERROR_HAS_OCCURED'),
            { size: 'sm' },
            'OK',
            null
          )
          .then(_ => {});
      },
      () => {
        gungAddRemoveSpinner(element.target);
      }
    );
  }
}
